import styled from '@emotion/styled';
import { OutlineInputControl } from 'components/Inputs/InputControl';
import { KizenTypography } from 'app/typography';
import Button from 'components/Button';
import IconSelector from 'components/MultiColumnBuilder/components/IconSelector';
import ColorPickerInput from 'components/Kizen/ColorPickerInput';

export const StyledTemplateButton = styled(Button)`
  margin: 0;
  padding-left: 0;
  width: fit-content;
`;

export const StyledTemplateButtonWrapper = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const StyledNotice = styled(KizenTypography)`
  padding: 10px;
  background-color: var(--color-feedback-info-bg);
  margin-bottom: 15px;
`;

export const StyledOutlineInputControl = styled(OutlineInputControl)`
  & label {
    margin-bottom: 0;
  }
`;

export const StyledTextTemplaterWrapper = styled.div`
  margin-bottom: 197px;
`;

export const StyledColorPickerInput = styled(ColorPickerInput)`
  label {
    & > span {
      margin-bottom: 18px;
    }
    & .styled-swatch {
      width: 16px;
      height: 16px;
    }
  }
`;

export const StyledIconSelector = styled(IconSelector)`
  && label {
    margin-bottom: 18px;
  }
  && .IconSelector__value-container {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 18px;
    width: 18px;
    height: 16px;
  }
  && .IconSelector__single-value {
    height: 16px;
    width: unset;
    margin: 0;
    padding: 0;
  }

  &&& i.DefaultIcon,
  i.ClassNameIcon {
    font-size: 16px;
    height: 16px;
    width: unset;
    svg {
      height: 16px;
    }
  }
`;
